import { Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import { ChannelForAllocatedList } from '../../../types/inventoryAllocatedList'
import useStyles from './styles/index.styles'

interface ChannelTitelProps {
  channelItem: ChannelForAllocatedList
}

const ChannelTitle = ({ channelItem }: ChannelTitelProps) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.rateplanRowNameContainer}>
        <Typography variant="body1" className={classes.rowName}>
          {channelItem.basicDetails.name}
        </Typography>

        <ArrowRightIcon className={[classes.channelArrowRight].join(' ')} />
      </div>
    </>
  )
}

export default ChannelTitle
